// react
import axios from 'axios';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import {
    Card,
    Button,
    Row,
    Col,
    CardBody,
    CardFooter,
    CardHeader,
    FormGroup,
    Label,
    Input,
    Container,
} from "reactstrap";
// third-party
import { Helmet } from 'react-helmet-async';
import { useParams, useHistory, Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { url } from '../../services/utils';
import { getAddressMap } from '../../api/getMapAddress';
import { Maps } from '../Maps';
import { useDispatch, useSelector } from 'react-redux';
import { updateAction } from '../../store/auth/authActions';
import PageHeader from '../shared/PageHeader';
// data stubs
import theme from '../../data/theme';

export default function AccountPageEditAddress(props) {
    const { addressid } = props;
    let History = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const queryParams = new URLSearchParams(location.search);
    const isFromCheckout =
        queryParams.get('from') === 'checkout' ||
        location.state?.from === '/shop/checkout' ||
        sessionStorage.getItem('EDIT_ADDRESS_FROM') === 'checkout';
    // const [provinceData, setProvinceData] = useState('');
    // const [cityData, setCityData] = useState([]);
    const [kecamatan, setKecamatan] = useState("");
    const [kecamatans, setKecamatans] = useState([]);
    const [desa, setDesa] = useState("");
    const [desas, setDesas] = useState([]);
    const [city, setCity] = useState("");
    const [phone, setPhone] = useState("");
    const [citys, setCitys] = useState([]);
    const [province, setProvince] = useState("");
    const [provinces, setProvinces] = useState([]);
    const [loading, setloading] = useState(false);
    const [long, setLong] = useState("");
    const [lat, setLat] = useState("");
    const [selectAddress, setSelectAddress] = useState("");
    const [loadMap, setLoadMap] = useState();
    const [loadMaps, setLoadMaps] = useState();
    const successCallback = (position) => {
        // console.log(position);
    };

    const errorCallback = (error) => {
        // console.log(error);
    };

    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    // const [bodyNew, setBodyNew] = useState({
    //     address:"",
    //     city:"",
    //     province:"",
    //     phone:""
    // });
    const [bodyUpdate, setBodyUpdate] = useState({
        address: "",
        active_flag: 1,
        city: "",
        province: "",
        phone: ""
    });
    const { addressId } = useParams()
    // const user_id = localStorage.getItem('user_id');
    // console.log(addressId)
    const { token } = useSelector((state) => state.auth)
    // console.log(bodyUpdate)
    const newSecondAddress = async () => {
        try {
            const result = await axios({
                method: "POST",
                url: `${process.env.REACT_APP_HOST_API}/address/kedua`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: bodyUpdate,
            });
            //   console.log(result.data.response);
            toast.success('Alamat Kedua Sukses');
            if (isFromCheckout) {
                sessionStorage.removeItem('EDIT_ADDRESS_FROM');
                History.push('/shop/checkout');
            } else {
                History.push('/account/addresses');
            }
        } catch (error) {
            console.log(error);
            toast.error('Alamat Kedua Gagal');
        }
    }
    const newThirdAddress = async () => {
        try {
            const result = await axios({
                method: "POST",
                url: `${process.env.REACT_APP_HOST_API}/address/ketiga`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: bodyUpdate,
            });
            console.log(result.data.response);
            toast.success('Alamat Ketiga Sukses');
            if (isFromCheckout) {
                sessionStorage.removeItem('EDIT_ADDRESS_FROM');
                History.push('/shop/checkout');
            } else {
                History.push('/account/addresses');
            }

        } catch (error) {
            // console.log(error)
            toast.error('Alamat Ketiga Gagal');
        }
    }
    const updateAddress = async () => {
        try {
            setloading(true)
            const result = await axios({
                method: "POST",
                url: `${process.env.REACT_APP_HOST_API}/address/pertama`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: bodyUpdate,
            });
            setloading(false)
            //   console.log(result.data.response);
            toast.success('Alamat Pertama Sukses');

        } catch (error) {
            setloading(false)
            console.log(error)
            toast.error('Alamat Pertama Gagal')
        }
    }

    const defaultProps = {
        center: {
            lat: lat || -7.3106144, // Default latitude
            lng: long || 112.6841525, // Default longitude
        },
        zoom: 14,
    };

    const onClickMap = async (e) => {
        if (!e || !e.lat || !e.lng) {
            console.error("Invalid event data from map click.");
            return;
        }

        setLong(e.lng);
        setLat(e.lat);

        try {
            const data = await getAddressMap(e.lat, e.lng);
            const addressText = data?.formatted_address || data?.display_name || (data?.results && data.results[0]?.formatted_address);
            if (addressText) {
                setSelectAddress(addressText);
                const pacInput = document.getElementById('pac-input');
                if (pacInput) pacInput.value = addressText;
            }
            if (loadMap && loadMaps && typeof loadMapClick === 'function') {
                loadMapClick(loadMap, loadMaps);
            }
        } catch (error) {
            console.error("Error fetching address:", error);
        }
    };

    const apiIsLoaded = (map, maps) => {
        if (!map || !maps) {
            console.error("Google Maps API failed to load or map/mapping is undefined.");
            return;
        }
        setLoadMap(map);
        setLoadMaps(maps);
        loadMapClick(map, maps); // Panggil fungsi loadMapClick hanya jika map dan maps tersedia
    };

    const loadMapClick = (map, maps, radius = 1000) => { // Default radius: 1000 meters
        if (!map || !maps) {
            console.error("Map or Maps object is undefined.");
            return;
        }

        const circle = new maps.Circle({
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.3,
            map: map,
            center: defaultProps.center,
            // radius: radius,
        });

        // console.log("Radius:", radius);
    };

    useEffect(() => {
        getbyId()

    }, [])


    const getbyId = async () => {
        try {
            const result = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_HOST_API}/address/get/${addressid}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            //   setBanks(result.data.response)
            getProvinsi(result.data.response.province)
            getCity(result.data.response.province)
            getKecamatan(result.data.response.city)
            getDesa(result.data.response.district)
            setProvince(result.data.response.province)
            setCity(result.data.response.city)
            setKecamatan(result.data.response.district)
            setDesa(result.data.response.village)
            setPhone(result.data.response.phone)
            setLong(result.data.response.longitude)
            setLat(result.data.response.latitude)
            setSelectAddress(result.data.response.address)
        } catch (error) {
            // console.log(error);
            // toast.error('There was an error!');
        }
    }

    const getProvinsi = async (id) => {
        try {
            const result = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_HOST_API}/province/list`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setProvinces(result.data.response)
            //   setProvince(id)
            //   getCity(id)
        } catch (error) {
            // console.log(error);
            // toast.error('There was an error!');
        }
    }

    const getCity = async (id) => {
        try {
            const result = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_HOST_API}/city/listing?province_id=${id}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCitys(result.data.response)
            //   setCity(id)
        } catch (error) {
            // console.log(error);
            // toast.error('There was an error!');
        }
    }

    const getKecamatan = async (id) => {
        try {
            const result = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_HOST_API}/district/listing?city_id=${id}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setKecamatans(result.data.response)
        } catch (error) {
        }
    }

    const getDesa = async (id) => {
        try {
            const result = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_HOST_API}/village/listing?district_id=${id}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setDesas(result.data.response)
        } catch (error) {
        }
    }

    const updateHandler = async () => {
        const id = localStorage.getItem('user_id');
        try {
            dispatch(updateAction(true))
            const result = await axios({
                method: "POST",
                url: `${process.env.REACT_APP_HOST_API}/address/update/${addressid}`,
                data: {
                    latitude: lat,
                    longitude: long,
                    address: selectAddress,
                    city: city,
                    province: province,
                    phone: phone,
                    district: kecamatan,
                    village: desa,
                    // rv_state : centang === "" ? 3 : 5 ,
                    // account_number : bank
                    // warehouse_id: toko,
                    // code_aplikator : kode,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
            });
            toast.success('Update Alamat Sukses');
            dispatch(updateAction(false));
            localStorage.setItem('CO-INFO', JSON.stringify(result.data.response));
            if (isFromCheckout) {
                sessionStorage.removeItem('EDIT_ADDRESS_FROM');
                const targetId = String(addressid || addressId || '');
                if (targetId) {
                    sessionStorage.setItem('CHECKOUT_SELECTED_ADDRESS_ID', targetId);
                    localStorage.setItem('CHECKOUT_SELECTED_ADDRESS_ID', targetId);
                }
                window.dispatchEvent(new CustomEvent('address:default_updated', { detail: targetId }));
                History.push("/shop/checkout");
            } else {
                History.push("/account/addresses");
            }
        } catch (error) {
            toast.error('Update Alamat Gagal');
            dispatch(updateAction(false));
        }
    };

    const setDefaultHandler = async () => {
        try {
            dispatch(updateAction(true));
            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_HOST_API}/address/default/${addressid}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            toast.success('Alamat berhasil dijadikan sebagai Alamat Utama');
            if (isFromCheckout) {
                sessionStorage.removeItem('EDIT_ADDRESS_FROM');
                const targetId = String(addressid || addressId || '');
                if (targetId) {
                    sessionStorage.setItem('CHECKOUT_SELECTED_ADDRESS_ID', targetId);
                    localStorage.setItem('CHECKOUT_SELECTED_ADDRESS_ID', targetId);
                    localStorage.setItem('DEFAULT_ADDRESS_ID', targetId);
                }
                window.dispatchEvent(new CustomEvent('address:default_updated', { detail: targetId }));
                History.push("/shop/checkout");
            } else {
                History.push("/account/addresses");
            }
        } catch (error) {
            console.error("Set default error:", error);
            toast.error('Gagal mengatur Alamat Utama');
        } finally {
            dispatch(updateAction(false));
        }
    };

    const deleteHandler = async () => {
        if (!window.confirm("Apakah Anda yakin ingin menghapus alamat ini?")) return;
        try {
            dispatch(updateAction(true));
            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_HOST_API}/address/delete/${addressid}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            toast.success('Alamat berhasil dihapus');
            if (isFromCheckout) {
                sessionStorage.removeItem('EDIT_ADDRESS_FROM');
                sessionStorage.removeItem('CHECKOUT_SELECTED_ADDRESS_ID');
                localStorage.removeItem('CHECKOUT_SELECTED_ADDRESS_ID');
                window.dispatchEvent(new CustomEvent('address:default_updated', { detail: null }));
                History.push("/shop/checkout");
            } else {
                History.push("/account/addresses");
            }
        } catch (error) {
            console.error("Delete error:", error);
            toast.error('Gagal menghapus alamat');
        } finally {
            dispatch(updateAction(false));
        }
    };

    // useEffect(() => {
    //     const getProvince = async (id) => {
    //       try {
    //         const result = await axios.get(
    //           `${process.env.REACT_APP_HOST_API}/city/listing?province_id=${id}`
    //         );
    //         // console.table(result.data.response);
    //         setProvinceData(result.data.response);
    //       } catch (error) {
    //         console.log(error);
    //         let errorMsg =
    //           error.code === 'ERR_NETWORK'
    //             ? 'network error'
    //             : error.response
    //             ? error.response.data.message || error.response.data.error
    //             : error;
    //         toast.error(errorMsg);
    //       }
    //     };
    //     const city = async () => {
    //       try {
    //         const result = await axios.get(
    //           `${process.env.REACT_APP_HOST_API}/city/listing?province_id=${bodyUpdate.province}`
    //         );
    //         // console.table(result.data.response);
    //         setCityData(result.data.response);
    //       } catch (error) {
    //         console.log(error);
    //         let errorMsg =
    //           error.code === 'ERR_NETWORK'
    //             ? 'network error'
    //             : error.response
    //             ? error.response.data.message || error.response.data.error
    //             : error;
    //         toast.error(errorMsg);
    //       }
    //     };
    //     getProvince();
    //     if (bodyUpdate.province) {
    //       city();
    //     }
    //   }, [bodyUpdate.province]);
    const breadcrumb = isFromCheckout ? [
        { title: 'Home', url: '/' },
        { title: 'Keranjang', url: '/cart' },
        { title: 'Checkout', url: '/shop/checkout' },
        { title: 'Edit Alamat', url: '' },
    ] : [
        { title: 'Home', url: '/' },
        { title: 'Akun Saya', url: '/account' },
        { title: 'Alamat', url: '/account/addresses' },
        { title: 'Edit Alamat', url: '' },
    ];

    return (
        <div className="block edit-address-page-block">
            <Helmet>
                <title>{`Ubah Alamat | ${theme.name}`}</title>
            </Helmet>

            <PageHeader breadcrumb={breadcrumb} />

            <div className="container hokky-cart-container">
                <div className="edit-address-wrapper">
                    {/* Header Banner */}


                    {/* Main Box */}
                    <div className="edit-address-main-box">
                        {/* Map Section */}
                        <div className="edit-address-map-section">
                            <div className="map-section-title">
                                <h5>
                                    <i className="fas fa-map-marker-alt" />
                                    <span>Titik Lokasi Pengiriman (Peta)</span>
                                </h5>
                                <span className="map-hint-badge">
                                    <i className="fas fa-info-circle" />
                                    <span>Klik atau geser pin pada peta untuk menentukan titik kurir</span>
                                </span>
                            </div>

                            <div className="map-frame-wrap">
                                <Maps
                                    defaultCenter={defaultProps.center}
                                    defaultZoom={defaultProps.zoom}
                                    onClickMap={onClickMap}
                                    apiIsLoaded={(map, maps) => apiIsLoaded(map, maps)}
                                    isSearch={true}
                                    long={long}
                                    lat={lat}
                                    address={selectAddress}
                                    setLong={setLong}
                                    setLat={setLat}
                                />
                            </div>
                        </div>

                        {/* Form Section */}
                        <div className="edit-address-form-section">
                            <div className="edit-address-form-grid">
                                {/* Alamat Lengkap */}
                                <div className="form-group-modern grid-col-full">
                                    <label htmlFor="checkout-street-address">
                                        <i className="fas fa-home" />
                                        <span>Alamat Lengkap (Jalan, No. Rumah, RT/RW, Patokan)</span>
                                    </label>
                                    <textarea
                                        className="input-modern"
                                        id="checkout-street-address"
                                        placeholder="Masukkan alamat lengkap pengiriman"
                                        value={selectAddress}
                                        onChange={(e) => setSelectAddress(e.target.value)}
                                        rows="3"
                                    />
                                </div>

                                {/* Provinsi */}
                                <div className="form-group-modern">
                                    <label htmlFor="checkout-province">
                                        <i className="fas fa-map" />
                                        <span>Provinsi</span>
                                    </label>
                                    <select
                                        id="checkout-province"
                                        value={province}
                                        className="select-modern"
                                        onChange={(e) => {
                                            setProvince(e.target.value);
                                            getCity(e.target.value);
                                        }}
                                    >
                                        <option value="">Pilih Provinsi</option>
                                        {provinces.map((prov) => (
                                            <option key={prov.id} value={prov.id}>
                                                {prov.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Kota */}
                                <div className="form-group-modern">
                                    <label htmlFor="checkout-city">
                                        <i className="fas fa-city" />
                                        <span>Kota / Kabupaten</span>
                                    </label>
                                    <select
                                        id="checkout-city"
                                        className="select-modern"
                                        value={city}
                                        onChange={(e) => {
                                            setCity(e.target.value);
                                            getKecamatan(e.target.value);
                                        }}
                                    >
                                        <option value="">Pilih Kota / Kabupaten</option>
                                        {citys.map((c) => (
                                            <option key={c.id} value={c.id}>
                                                {c.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Kecamatan */}
                                <div className="form-group-modern">
                                    <label htmlFor="checkout-kecamatan">
                                        <i className="fas fa-building" />
                                        <span>Kecamatan</span>
                                    </label>
                                    <select
                                        id="checkout-kecamatan"
                                        className="select-modern"
                                        value={kecamatan}
                                        onChange={(e) => {
                                            setKecamatan(e.target.value);
                                            getDesa(e.target.value);
                                        }}
                                    >
                                        <option value="">Pilih Kecamatan</option>
                                        {kecamatans.map((kec) => (
                                            <option key={kec.id} value={kec.id}>
                                                {kec.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Desa/Kelurahan */}
                                <div className="form-group-modern">
                                    <label htmlFor="checkout-desa">
                                        <i className="fas fa-map-pin" />
                                        <span>Desa / Kelurahan</span>
                                    </label>
                                    <select
                                        id="checkout-desa"
                                        className="select-modern"
                                        value={desa}
                                        onChange={(e) => setDesa(e.target.value)}
                                    >
                                        <option value="">Pilih Desa / Kelurahan</option>
                                        {desas.map((d) => (
                                            <option key={d.id} value={d.id}>
                                                {d.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Phone */}
                                <div className="form-group-modern grid-col-full">
                                    <label htmlFor="checkout-phone">
                                        <i className="fas fa-phone-alt" />
                                        <span>Nomor Telepon / WhatsApp Penerima</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="input-modern"
                                        id="checkout-phone"
                                        placeholder="Contoh: 081234567890"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="edit-address-actions">
                                <Link
                                    to={isFromCheckout ? "/shop/checkout" : "/account/addresses"}
                                    className="btn-cancel-address"
                                    onClick={() => {
                                        if (isFromCheckout) {
                                            sessionStorage.removeItem('EDIT_ADDRESS_FROM');
                                        }
                                    }}
                                >
                                    <span>{isFromCheckout ? "Kembali ke Checkout" : "Kembali"}</span>
                                </Link>
                                <button
                                    type="button"
                                    className="btn-address-action btn-address-action--default"
                                    onClick={setDefaultHandler}
                                    style={{ height: '46px', padding: '0 20px', borderRadius: '12px' }}
                                >
                                    <i className="far fa-star mr-1" />
                                    <span>Jadikan Utama</span>
                                </button>
                                <button
                                    type="button"
                                    className="btn-address-action btn-address-action--delete"
                                    onClick={deleteHandler}
                                    style={{ height: '46px', padding: '0 18px', borderRadius: '12px' }}
                                >
                                    <i className="fas fa-trash-alt mr-1" />
                                    <span>Hapus</span>
                                </button>
                                <button
                                    type="button"
                                    className={classNames('btn-save-address', { 'btn-loading': loading })}
                                    onClick={updateHandler}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <i className="fas fa-spinner fa-spin" />
                                    ) : (
                                        <>
                                            <i className="fas fa-check mr-1" />
                                            <span>Simpan</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
